import { ko } from "../../../../date-fns/locale/ko.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    ko
  }
};